import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Stack, Typography, Grid } from '@mui/material';
import { InputText } from 'app/components/elements/InputText';
import { InputSelect, SelectOptions } from 'app/components/elements/InputSelect';

type DebtorDetail = {
  name?: string;
  address?: string;
  phoneNumber?: string;
  email?: string;
  employer?: string;
  employerPhone?: string;
  vin?: string;
  otherAddress?: string;
  fileNumber?: string;
};

type FormRedemption = {
  debtorDetail: DebtorDetail;
};
type DebtorDetailSectionProps = {
  optionsAddress: SelectOptions[];
};
const DebtorDetailSection = ({ optionsAddress }: DebtorDetailSectionProps) => {
  const {
    register,
    control,
    watch,
    formState: { errors }
  } = useFormContext<FormRedemption>();
  const watchShowOtherAddress = watch('debtorDetail.address');

  return (
    <Stack>
      <Typography style={{ fontSize: 16, fontWeight: 700, marginBottom: 8 }}>
        Debtor Details
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <InputText
            inputError={errors?.debtorDetail?.name?.message as string}
            placeholder="Enter name"
            title="Name"
            inputProps={{
              ...register('debtorDetail.name'),
              disabled: true
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3} gap={2}>
          <Controller
            control={control}
            name="debtorDetail.address"
            render={({ field: { onChange, value, onBlur } }) => (
              <InputSelect
                inputError={errors.debtorDetail?.address?.message}
                style={{ height: 50 }}
                title={'Address'}
                placeholder={'Select an address'}
                options={optionsAddress}
                value={value}
                onBlur={onBlur}
                onChange={(event) => {
                  onChange(event);
                }}
              />
            )}
          />
          {watchShowOtherAddress === 'other' && (
            <InputText
              placeholder={'Other Address'}
              inputProps={{
                ...register('debtorDetail.otherAddress'),
                style: { marginTop: 10 }
              }}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <InputText
            inputError={errors?.debtorDetail?.phoneNumber?.message as string}
            placeholder="Enter phone number"
            title="Phone Number"
            inputProps={{
              ...register('debtorDetail.phoneNumber')
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <InputText
            inputError={errors?.debtorDetail?.email?.message as string}
            placeholder="Enter email"
            title="Email"
            inputProps={{
              ...register('debtorDetail.email')
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <InputText
            inputError={errors?.debtorDetail?.employer?.message as string}
            placeholder="Enter employer"
            title="Employer"
            inputProps={{
              ...register('debtorDetail.employer')
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <InputText
            inputError={errors?.debtorDetail?.employerPhone?.message as string}
            placeholder="Enter employer phone"
            title="Employer Phone"
            inputProps={{
              ...register('debtorDetail.employerPhone')
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <InputText
            inputError={errors?.debtorDetail?.vin?.message as string}
            placeholder="Enter VIN"
            title="VIN"
            inputProps={{
              ...register('debtorDetail.vin'),
              disabled: true
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <InputText
            inputError={errors?.debtorDetail?.fileNumber?.message as string}
            placeholder="Enter file number"
            title="File Number"
            inputProps={{
              ...register('debtorDetail.fileNumber'),
              disabled: true
            }}
          />
        </Grid>
      </Grid>
    </Stack>
  );
};

export default DebtorDetailSection;
